import React from 'react'

import CreateTableObject from './CreateTableObject';
import TableWrapper from './TableWrapper'

function SetupTableData(props) {
    const tableObject = CreateTableObject(props.TableCreator)
    
    if (props.MassiveUploadTemplateUrlContext) {
        tableObject.setMassiveUploadTemplateUrlContext(props.MassiveUploadTemplateUrlContext);
    }

    return (
        <div key={'div_ab'} style={props.style}>
            <TableWrapper
                TableObject={tableObject}
                additionalFilters={tableObject.getAdditionalFilters()}
                initialFilters={tableObject.getInitialFilters()}
                client={tableObject.client}
                currentTableCount={tableObject.tableCountSelector}
                currentTableFilters={tableObject.tableFiltersSelector}
                currentTableColumns={tableObject.tableColumnsSelector}
                currentTableSlectAllState={tableObject.tableSlectAllStateSelector}
                currentTableSelectedRows={tableObject.tableSelectedRowsSelector}
                currentTableSelectedRefs={tableObject.tableSelectedRefsSelector}
                stickyHeader
            >
                {props.children}
            </TableWrapper>
        </div>
    )    
}

export default SetupTableData
